import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import { BaseComponent } from '@/components/base-component';
import { CountUpItem } from '@/components/count-up-item/count-up-item';

@Component
export class Pagination extends BaseComponent {
	@Prop() totalPages: number;
	@Prop() morePage: number;
	currentPage = 1;

	@Watch('morePage')
	onMorePage() {
		this.currentPage = this.morePage
	}

	get pagesToShow() {
		const total = this.totalPages;
		const current = this.currentPage;
		const pages = [];
		const delta = 2; // kolik čísel kolem aktuální stránky ukazovat

		// pokud je malo stranek
		if (total <= 7) {
			for (let i = 1; i <= total; i++) pages.push(i);
			return pages;
		}

		// zacatek
		if (current <= 4) {
			pages.push(1, 2, 3, 4, 5, '...', total);
			return pages;
		}

		// konec
		if (current >= total - 3) {
			pages.push(1, '...');
			for (let i = total - 4; i <= total; i++) {
				pages.push(i);
			}
			return pages;
		}

		// streed
		pages.push(1, '...');
		for (let i = current - delta; i <= current + delta; i++) {
			pages.push(i);
		}
		pages.push('...', total);

		return pages;
	}

	@Emit('pageChanged')
	goToPage(page: number) {
		if (page < 1 || page > this.totalPages) {
			return;
		}

		this.currentPage = page;
	}
}

export default Pagination;
